module.exports = "<alert></alert>\r\n<router-outlet ></router-outlet>\r\n"